// @flow

type State = $ReadOnlyArray<string>;
const initialState: State = [];

export const neolidsReducer = (state: State = initialState, action: Action<*>) => {
  // there is just a switch with a default case because data is initialized in src/client/store/getInitialReduxState.client.js
  // and is never changed after that (data come from query params)
  switch (action.type) {
    default:
      return state;
  }
};
